import Debug from 'debug'
import { StateMachine } from '@/app/shared/state-machine'
import * as States from './states'
import * as Data from './data'

interface Question {
  score: Data.QuestionScore
}

type State = States.NotAnsweredState | States.AnsweredState | States.EvaluatedState | States.SolutionShownState

const debug = Debug('question-state-machine')

export class QuestionStateMachine {

  private stateMachine: StateMachine<State, Data.QuestionPhase>

  
  constructor(private data: Data.QuestionStateMachineData,
              private question : Question) {

    debug('constructor', data, question)

    this.stateMachine = new StateMachine('question-state-machine');
    this.stateMachine.addStateChangedListener((phase) => {
      this.data.phase = phase
    })

    switch (data.phase) {
      case 'not-answered':
        this.goToNotAnsweredState()
        break
      case 'answered':
        this.goToAnsweredState()
        break
      case 'evaluated':
        this.goToEvaluatedState()
        break
      case 'solution-shown':
        this.goToSolutionShownState()
        break
    }
  }

  private goToNotAnsweredState() {
    const state = new States.NotAnsweredState(this.data)
    this.stateMachine.changeState(state, {
      onAnswerChanged: () => this.goToAnsweredState()
    });
  }

  private goToAnsweredState() {

    const state = new States.AnsweredState(this.data, this.question.score)
    this.stateMachine.changeState(state, {
      onEvaluate: () => this.goToEvaluatedState(),
      onReset: () => this.handleReset()
    })
  }

  private goToEvaluatedState() {
    const state = new States.EvaluatedState(this.data, this.question.score)
    this.stateMachine.changeState(state, {
      onShowSolution: () => this.goToSolutionShownState(),
      onReset: () => this.handleReset()
    })
  }

  private goToSolutionShownState() {
    const state = new States.SolutionShownState(this.data, this.question.score)
    this.stateMachine.changeState(state, {
      onReset: () => this.handleReset()
    })
  }

  private handleReset() {
    this.goToNotAnsweredState()
  }

  updateAnswer(answer: Data.QuestionAnswer) {
    this.stateMachine.executeAction('updateAnswer', answer)
  }

  updateState(state: Data.QuestionState) {    
    this.stateMachine.executeAction('updateState', state)
  }

  updateEvaluation(evaluation: Data.QuestionEvaluationResult) {
    this.stateMachine.executeAction('updateResult', evaluation)
  }

  evaluate() {
    this.stateMachine.executeAction('evaluate')
  }

  showSolution() {
    this.stateMachine.executeAction('showSolution')
  }

  reset() {
    this.stateMachine.executeAction('reset')
  }
}
